import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@xolv-mybrightlink/security';

export const AuthProviderRoute = () => {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
};
